import styled from 'styled-components';

export const Container = styled.div`
  /* background-color: red; */
  overflow: hidden;
  width: 75vw;
  height: 75vh;

   div {
    width: 100%;
    height: 100%;
  }

  .custom-map-controls {
    width: auto !important;
    height: auto !important;
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    button {
      padding: 0 !important;
      margin-bottom: 0 !important;
      color: #fff;
      background-color: rgba(0,0,0,.6);
      background-position: 50%;
      background-size: 44px;
      height: 32px;
      width: 32px;
      box-shadow: none;
      border: none;
      font-size: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    button:disabled {
      opacity: .5;
    }
  }

  .react-slideshow-wrapper.slide {
    width: 100%;
    height: 100%;
  }

  .react-slideshow-container {
    button.nav.default-nav {
      background-position: 50%;
      background-size: 50px;
      height: 50px;
      width: 50px;
      border-radius: 0;
      background-color: rgba(0,0,0,.25);
      opacity: .75;
      color: #fff;
      fill: #fff;
    }
  }
`;

export const Pagination = styled.div`
    background-color: rgba(0,0,0,.25);
    border-radius: 12px;
    font-size: 12px;
    height: 24px;
    left: 46px;
    line-height: 24px;
    min-width: 42px;
    top: 46px;
    position: absolute;
    opacity: .75;
    padding: 0 10px;
    color: #fff;  
    user-select: none;
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
`;

export const Imagens = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;
  touch-action: none;

  img {
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }
`;

export const BoxImage = styled.div`
  img {
    width: 100% !important;
    height: 100% !important;
    max-width: unset !important;
    max-height: unset !important;
    object-fit: scale-down !important;
  }
`;

export const ContainerImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DownloadButton = styled.button`
  position: absolute;
  right: 10px;
  top: 10px; 
  z-index: 100;
  height: 32px;
  width: 30px;
  border: none;
  background-color: rgba(0, 0, 0, 0.6); 
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0;

  svg {
    font-size: 22px;
  }

  &.disable {
    opacity: 0.5;
  }
`;